<template>
    <div>
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWe66pj.png" width="100%" />
        <div class="inputForm">
            <div v-if="query.type==='jiaodai'">
                <van-row>
                    <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWNhl9I.png" width="90%"/>
                </van-row>
                <van-row>
                    万次纳米双面胶贴强力透明胶带
                </van-row>
            </div>
            <div v-else-if="query.type==='shujuxian'">
                <van-row>
                    <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWNhl9J.png" width="90%"/>
                </van-row>
                <van-row>
                    一拖三数据线
                </van-row>
            </div>
            <div v-else-if="query.type==='jiandao'">
                <van-row>
                    <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWHw6sP.png" width="90%"/>
                </van-row>
                <van-row>
                    文具剪刀
                </van-row>
            </div>
            <div v-else-if="query.type==='bi'">
                <van-row>
                    <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWBrY33.png" width="90%"/>
                </van-row>
                <van-row>
                    0.5mm中性笔
                </van-row>
            </div>

            <div style="font-size:1rem;margin-top:2rem;">
                温馨提示<br/>
                完成淘宝特价版首购后，次日进入本页面<br/>
                选择任意商品，0元抢购
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                query: {
                    type: this.$route.query.type,
                },
            }
        },
    }

</script>

<style lang="scss" scoped>

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        padding: 1rem;
        text-align: center;
    }

</style>
